module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4r3r1r2r-e1a8eda545c02b096cec851d0dd27941.svg";